import appLogo from '../assets/logo/logo-t-1.png'

export const Footer = () => {
    const handleLinkClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            <section className="px-[0.5rem] md:px-[0.8rem] pb-[0.4rem] pt-[1rem] bg-[#ebf3f3] font-jakarta">
                <section className="flex justify-between items-center pb-[5.5rem] bg-[#001f19] rounded-2xl px-[20px] md:px-[5rem] py-[1rem] md:py-[2rem]">
                    <div className="flex items-center gap-[3rem]">
                        <span className="text-[#9CA3AF] text-[0.8rem] md:text-[1rem]">© 2024 thobyza.work</span>
                    </div>
                    <div className="flex gap-[1.25rem] md:gap-[1.75rem] items-center">
                        <img src={appLogo} alt="" className="h-[1.6em] md:h-[2.4rem] object-cover" />
                        <div
                            onClick={handleLinkClick}
                            className="flex items-center justify-center rounded-full p-[0.9rem] md:p-[1.1rem] bg-[#0b271b] hover:bg-[#0e2f21] group cursor-pointer transition ease-in-out delay-125"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 1024 1024"
                                className="h-[0.8rem] w-[0.8rem] md:h-[1.2rem]  md:w-[1.2rem] rotate-180 text-[#D0D0D0] group-hover:scale-[1.2] transition ease-in-out delay-125"
                            >
                                <path
                                    fill="currentColor"
                                    d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8l316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496"
                                />
                            </svg>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}